import { render, staticRenderFns } from "./SingleStat.vue?vue&type=template&id=9c8f57f8&scoped=true"
import script from "./SingleStat.vue?vue&type=script&lang=js"
export * from "./SingleStat.vue?vue&type=script&lang=js"
import style0 from "./SingleStat.vue?vue&type=style&index=0&id=9c8f57f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8f57f8",
  null
  
)

export default component.exports